import React from 'react'

export const cancerAllContent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <p>CYTOGENETIC RISK GROUPS FOR B-ALL</p>
      <table>
        <thead>
          <tr>
            <th style={{ border: "1px solid black" }}>RISK GROUPS</th>
            <th style={{ border: "1px solid black" }}>CYTOGENETICS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black" }}>Good Risk</td>
            <td style={{ border: "1px solid black" }}>
              <li>Hyperdiploidy (51-65 chromosomes)</li>
              <p style={{ marginLeft: "10px" }}>&#9658;Cases with trisomy of chromosomes 4, 10, and 17 appear to have the most favourable outcome</p>
              <li>t(12;21)(p13;q22); ETV6-RUNX1<sup>a</sup></li>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Poor Risk</td>
            <td style={{ border: "1px solid black" }}>
              <li>Hypodiploidy<sup>b,c</sup> (less than 44 chromosomes)</li>
              <li>KMT2A rearranged (t[4;11] or others)</li>
              <li>t(v;14q32)/lgH</li>
              <li>t(9;22)(q34;q11.2): BCR-ABL1 (defined as high risk in the pre-TKI era)</li>
              <li>Complex karyotype (5 or more chromosomal abnormalities)</li>
              <li>BCR-ABL 1-like (Ph-like) ALL</li>
              <p style={{ marginLeft: "10px" }}>&#9658; JAK-STAT (CRLF2r,<sup>c,d</sup> EPORr, JAK1/2/3r, TYK2r, mutations of SH2B3, IL7R, JAK 1/2/3)</p>
              <p style={{ marginLeft: "10px" }}>&#9658; ABL class (rearrangements of ABL1, ABL2, PDGFRA, PDGFRB, FGFR)</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Other (NTRKr, FLT3r, LYNr, PTK2Br)</p>
              <li>Intrachromosomal amplification of chromosome 21 (iAMP21)</li>
              <li>t(17;19): TCF3-HLF fusion</li>
              <li>Alterations of IKZF1<sup>e,f</sup></li>
            </td>
          </tr>
        </tbody>
      </table>
    </div >
  )
}

export const cancerAmlContent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <p>RISK STRATIFICATION BY GENETICS IN NON-APL AML<sup>1,2</sup></p>
      <table>
        <thead style={{ border: "1px solid black" }}>
          <tr>
            <th style={{ border: "1px solid black" }}>RISK Category*</th>
            <th style={{ border: "1px solid black" }}>Genetic Abnormality</th>
          </tr>
        </thead>
        <tbody style={{ border: "1px solid black" }}>
          <tr>
            <td style={{ border: "1px solid black" }}>Favourable</td>
            <td style={{ border: "1px solid black" }}>
              <p>t(8;21)(q22;q22.1); RUNX1-RUNX1T1</p>
              <p>inv(16)(p13. 1q22) or t(16;16)(p13.1;q22); CBFB-MYH11</p>
              <p>Biallelic mutated CEBPA</p>
              <p>Mutated NPM1 without FLT3-ITD or with FLT3-ITD<sup>low†</sup></p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Intermediate</td>
            <td style={{ border: "1px solid black" }}>
              <p>Mutated PM1 and FLT3-ITD<sup>high†</sup></p>
              <p>Wild-type NPM1 without FLT3-ITD or with FLT3-ITD<sup>low†</sup> (without adverse-risk genetic lesions)</p>
              <p>t(9;11)(p21.3;q23.3); MLLT3-KMT2A<sup>†</sup></p>
              <p>Cytogenetic abnormalities not classified as favorable or adverse</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Poor/Adverse</td>
            <td style={{ border: "1px solid black" }}>
              <p>t(6;9)(p23;q34.1); DEK-NUP214</p>
              <p>t(v;11q23.3); KMT2A rearranged</p>
              <p>t(9;22)(q34.1;q11.2); BCR-ABL1</p>
              <p>inv(3)(q21.3q26.2) or t(3;3)(q21.3;q26.2); GATA2,MECOM(EVI1)</p>
              <p>-5 or del(5q); -7; -17/abn(17p)</p>
              <p>Complex karyotype,<sup>$$</sup> monosomal karyotype<sup>||</sup></p>
              <p>Wild-type NPM1 and FLT3-ITD<sup>high†</sup></p>
              <p>Mutated RUNX1<sup>&prod;</sup></p>
              <p>Mutated ASXL1<sup>&prod;</sup></p>
              <p>Mutated TP53<sup>#</sup></p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const cancerAmlContentApl = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <p>APL CLASSIFICATION AND TREATMENT RECOMMENDATION</p>
      <table>
        <tbody style={{ border: "1px solid black" }}>
          <tr>
            <td style={{ border: "1px solid black" }}>Confirmed APL<sup>a</sup></td>
            <td style={{ border: "1px solid black" }}>
              <tr>
                <td>
                  <p>Low risk (WBC count &lt;=10,000/mcL)</p>
                  <p>High risk (WBC count &gt;10,000/mcL)</p>
                </td>
                {/* <td></td> */}
              </tr>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const cancerBladderContent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <p>AUA RISK STRATIFICATION FOR NON-MUSCLE INVASIVE BLADDER CANCER*</p>
      <table>
        <thead style={{ border: "1px solid black" }}>
          <tr>
            <th style={{ border: "1px solid black" }}>Low Risk</th>
            <th style={{ border: "1px solid black" }}>Intermediate Risk</th>
            <th style={{ border: "1px solid black" }}>High Risk</th>
          </tr>
        </thead>
        <tbody style={{ border: "1px solid black" }}>
          <tr>
            <td style={{ border: "1px solid black" }}>
              <li>Papillary urothelial neoplasm of low
                malignant potential</li>
              <li>Low grade urothelial carcinoma</li>
              <p style={{ marginLeft: "10px" }}>&#9658; Ta and</p>
              <p style={{ marginLeft: "10px" }}>&#9658; ≤3 cm and</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Solitary</p>
            </td>
            <td style={{ border: "1px solid black" }}>
              <li>Low grade urothelial carcinoma</li>
              <p style={{ marginLeft: "10px" }}>&#9658; T1 or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; &gt;3 cm or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Multifocal or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Recurrence within 1 year</p>
              <li>High grade urothelial carcinoma</li>
              <p style={{ marginLeft: "10px" }}>&#9658; Ta and</p>
              <p style={{ marginLeft: "10px" }}>&#9658; ≤3 cm and</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Solitary</p>
            </td>
            <td style={{ border: "1px solid black" }}>
              <li>High grade urothelial carcinoma</li>
              <p style={{ marginLeft: "10px" }}>&#9658; CIS or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; T1 or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; &gt;3 cm or</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Multifocal</p>
              <li>Very high risk features (any):</li>
              <p style={{ marginLeft: "10px" }}>&#9658; BCG unresponsive<sup>l</sup></p>
              <p style={{ marginLeft: "10px" }}>&#9658; Variant histologiesm</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Lymphovascular invasion</p>
              <p style={{ marginLeft: "10px" }}>&#9658; Prostatic urethral invasion</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const cancerProstateContent = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
      <p>AUA RISK STRATIFICATION FOR NON-MUSCLE INVASIVE PROSTATE CANCER*</p>
      <table>
        <thead style={{ border: "1px solid black" }}>
          <tr>
            <th style={{ border: "1px solid black" }}>Risk Group</th>
            <th style={{ border: "1px solid black" }}>
              Clinical/Pathologic Features
            </th>
          </tr>
        </thead>
        <tbody style={{ border: "1px solid black" }}>
          <tr>
            <td style={{ border: "1px solid black" }}>Very low*</td>
            <td style={{ border: "1px solid black" }}>
              Has all of the following:
              <li>cT1c</li>
              <li>Grade Group 1</li>
              <li>PSA less than 10 ng/mL</li>
              <li>Fewer than 3 prostate biopsy fragments/cores positive, ≤50% cancer in each fragment/core</li>
              <li>PSA density less than 0.15 ng/mL/g</li>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Low*</td>
            <td style={{ border: "1px solid black" }}>
              Has all of the following but does not qualify for very low risk:
              <li>cT1-cT2a</li>
              <li>Grade Group 1</li>
              <li>PSA less than 10 ng/mL</li>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Intermediate*</td>
            <td>
              <td style={{ borderRight: "1px solid black" }}>
                Has all of the following:
                <li>No high-risk group features</li>
                <li>No very-high-risk group features</li>
                <li>Has one or more intermediate rirsk factors (IRF's)</li>
                <p style={{ marginLeft: "10px" }}>&#9658;cT2b-cT2c</p>
                <p style={{ marginLeft: "10px" }}>&#9658;Grade Group 2 or 3</p>
                <p style={{ marginLeft: "10px" }}>&#9658;PSA 10-20 ng/mL</p>
              </td>
              <td style={{ borderRight: "1px solid black", borderLeft: "1px solid black", width: "300px" }}>
                <tr>
                  <td style={{ borderBottom: "1px solid black", position: "relative", bottom: "25px", width: "300px", textAlign : "center" }}>Favourable Intermediate</td>
                </tr>
                <tr>
                  <td style={{ position: "relative", top: "30px", textAlign: "center" }}>Unfavourable Intermediate</td>
                </tr>
              </td>
              <td style={{width : "500px"}}>
                <tr>
                  <td style={{ borderBottom: "1px solid black", width: "500px" }}>
                    Has all of the following:
                    <li>1 IRF</li>
                    <li>Grade Group 1 or 2</li>
                    <li> &lt;50% biopsy cores positive (eg, &lt;6 of 12 cores)<sup>f</sup></li>
                  </td>
                </tr>
                <tr>
                  <td>
                    Has one or more of the following:
                    <li>2 or 3 IRF's</li>
                    <li>Grade Group 3</li>
                    <li> &gt;=50% biopsy cores positive (eg, &gt;=6 of 12 cores)<sup>f</sup></li>
                  </td>
                </tr>
              </td>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>High</td>
            <td style={{ border: "1px solid black" }}>
              Has no very-high-risk features and has exactlty one high-risk feature:
              <li>cT3a OR</li>
              <li>Grade Group 4 or Grade Group 5 OR</li>
              <li>PSA &gt; 20 ng/mL</li>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Very High</td>
            <td style={{ border: "1px solid black" }}>
              Has atleast one of the following:
              <li>cT3b-cT4</li>
              <li>Primary Gleason pattern 5</li>
              <li>2 or 3 high-risk features</li>
              <li>&gt; 4 cores with Grade Group 4 or 5</li>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const cancerTesticularContent = () => {
  return (
    <div>
      <p>RISK CLASSIFICATION FOR ADVANCED DISEASE</p>
      <p>(post-orchiectomy)<sup>a,b</sup></p>
      <table>
        <thead>
          <tr>
            <th style={{ border: "1px solid black" }}>Risk Status </th>
            <th style={{ border: "1px solid black" }}>Nonseminoma</th>
            <th style={{ border: "1px solid black" }}>Seminoma</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black" }}>Good Risk</td>
            <td style={{ border: "1px solid black" }}>
              <p>Testicular or retroperitoneal primary
                tumor<sup>c</sup></p>
              <p>and</p>
              <p>No nonpulmonary visceral metastases</p>
              <p>and</p>
              <p style={{ textDecoration: "underline" }}>Post-orchiectomy markers</p>- all of:
              <p>AFP &lt; 1,000 ng/mL</p>
              <p>hCG &lt; 5,000 iu/L</p>
              <p>LDH &lt; 1.5 x upper limit of normal</p>
            </td>
            <td style={{ border: "1px solid black" }}>
              <p>Any primary site</p>
              <p>and</p>
              <p>No nonpulmonary visceral metastases</p>
              <p>and</p>
              <p>Normal AFP</p>
              <p>Any hCG</p>
              <p>Any LDH</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Intermediate Risk</td>
            <td style={{ border: "1px solid black" }}>
              <p>Testicular or retroperitoneal primary tumor<sup>c</sup></p>
              <p>and</p>
              <p>No nonpulmonary visceral metastases</p>
              <p>and</p>
              <p style={{ textDecoration: "underline" }}>Post-orchiectomy markers</p>-any of:
              <p>AFP 1,000-10,000 ng/mL</p>
              <p>hCG 5,000-50,000 iu/L</p>
              <p>LDH 1.5-10 x upper limit of normal</p>
            </td>
            <td style={{ border: "1px solid black" }}>
              <p>Any primary site</p>
              <p>and</p>
              <p>Nonpulmonary visceral metastases</p>
              <p>and</p>
              <p>Normal AFP</p>
              <p>Any hCG</p>
              <p>Any LDH</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Poor Risk</td>
            <td style={{ border: "1px solid black" }}>
              <p>Mediastinal primary tumor<sup>c</sup></p>
              <p>or</p>
              <p>Nonpulmonary visceral metastases</p>
              <p>or</p>
              <p style={{ textDecoration: "underline" }}>Post-orchiectomy markers</p>-any of:
              <p>AFP &gt; 10,000 ng/mL</p>
              <p>hCG &gt; 50,000 iu/L</p>
              <p>LDH &gt; 10 x upper limit of normal</p>
            </td>
            <td style={{ border: "1px solid black" }}>
              No patients classified as poor
              prognosis
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export const standardResponseCriteria = () => {
  return (
    <div>
      <p style={{ textAlign: "center" }}>RESPONSE CRITERIA FOR MULTIPLE MYELOMA</p>
      <p style={{ textAlign: "center" }}>(Revised based on the new criteria by International Myeloma Working Group [IMWG])</p>
      <table style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th colSpan={2} style={{ border: "1px solid black" }}>IMWG criteria for response assessment including criteria for minimal residual disease (MRD)</th>
          </tr>
          <tr>
            <th style={{ border: "1px solid black" }}>Response Category<sup>a</sup></th>
            <th style={{ border: "1px solid black" }}>Response Criteria </th>
          </tr>
          <tr>
            <th colSpan={2} style={{ border: "1px solid black" }}>IMWG MRD criteria (requires a complete response as defined below)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black" }}>Sustained MRD-negative</td>
            <td style={{ border: "1px solid black" }}>MRD negativity in the marrow (next-generation flow [NGF], next-generation sequencing [NGS], or both) and by imaging as defined below, confirmed minimum of 1 year apart. Subsequent evaluations can be used to further specify the duration of negativity (eg, MRD-negative at 5 years).<sup>b</sup></td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Flow MRD-negative</td>
            <td style={{ border: "1px solid black" }}>Absence of phenotypically aberrant clonal plasma cells by NGF<sup>c</sup> on bone marrow aspirates using the EuroFlow standard operation procedure for MRD detection in multiple myeloma (or validated equivalent method) with a minimum sensitivity of 1 in 10<sup>5</sup> nucleated cells or higher.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Sequencing MRD-negative</td>
            <td style={{ border: "1px solid black" }}>Absence of clonal plasma cells by NGS on bone marrow aspirate in which presence of a clone is defined as less than two identical sequencing reads obtained after DNA sequencing of bone marrow aspirates using a validated equivalent method with a minimum sensitivity of 1 in 10<sup>5</sup> nucleated cells<sup>d</sup> or higher.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Imaging plus MRD-negative</td>
            <td style={{ border: "1px solid black" }}>MRD negativity as defined by NGF or NGS plus disappearance of every area of increased tracer uptake found at baseline or a preceding FDG PET/CT or decrease to less mediastinal blood pool standardized uptake value (SUV) or decrease to less than that of surrounding normal tissue.<sup>e</sup></td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th colSpan={2} style={{ border: "1px solid black" }}>Standard IMWG response criteria<sup>f</sup></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ border: "1px solid black" }}>Stringent complete response</td>
            <td style={{ border: "1px solid black" }}>Complete response as defined below plus normal FLC ratio<sup>g</sup> and absence of clonal cells in bone marrow biopsy by immunohistochemistry (κ/λ ratio ≤4:1 or ≥1:2 for κ and λ patients, respectively, after counting ≥100 plasma cells).</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Complete response<sup>I</sup></td>
            <td style={{ border: "1px solid black" }}>Negative immunofixation on the serum and urine and disappearance of any soft tissue plasmacytomas and &lt;5% plasma cells in bone marrow aspirates.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Very good partial response</td>
            <td style={{ border: "1px solid black" }}>Serum and urine M-protein detectable by immunofixation but not on electrophoresis or ≥90% reduction in serum M-protein plus urine M-protein level &lt;100 mg per 24 h</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Partial response</td>
            <td style={{ border: "1px solid black" }}>&gt;=50% reduction of serum M-protein plus reduction in 24-h urinary M-protein by &gt;=90% or to &lt;200 mg per 24 h.
              If the serum and urine M-protein are unmeasurable, a ≥50% decrease in the difference between involved and
              uninvolved FLC levels is required in place of the M-protein criteria.
              If serum and urine M-protein are unmeasurable, and serum-free light assay is also unmeasurable, ≥50% reduction
              in plasma cells is required in place of M-protein, provided baseline bone marrow plasma-cell percentage was ≥30%.
              In addition to these criteria, if present at baseline, a ≥50% reduction in the size (sum of the products of the maximal
              perpendicular diameters [SPD] of measured lesions)<sup>j</sup>
              of soft tissue plasmacytomas is also required.
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Minimal response</td>
            <td style={{ border: "1px solid black" }}>≥25% but ≤49% reduction of serum M-protein and reduction in 24-h urine M-protein by 50%–89%. In addition to the above listed criteria, if present at baseline, a 25%–49% reduction in SPD<sup>j</sup> of soft tissue plasmacytomas is also required.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Stable disease</td>
            <td style={{ border: "1px solid black" }}>Not recommended for use as an indicator of response; stability of disease is best described by providing the time-to progression estimates. Not meeting criteria for complete response, very good partial response, partial response, minimal response, or progressive disease.</td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Progressive disease<sup>k,I</sup></td>
            <td style={{ border: "1px solid black" }}>
              <p>Any one or more of the following criteria:</p>
              <p>Increase of 25% from lowest confirmed response value in one or more of the following criteria:</p>
              <p>Serum M-protein (absolute increase must be ≥0.5 g/dL); Serum M-protein increase ≥1 g/dL, if the lowest M component was ≥5 g/dL;</p>
              <p>Urine M-protein (absolute increase must be ≥200 mg/24 h);</p>
              <p>In patients without measurable serum and urine M-protein levels, the difference between involved and uninvolved FLC levels (absolute increase must be &lt;10 mg/dL);</p>
              <p>In patients without measurable serum and urine M-protein levels and without measurable involved FLC levels, bone marrow plasma-cell percentage irrespective of baseline status (absolute increase must be ≥10%);</p>
              <p>Appearance of a new lesion(s), ≥50% increase from nadir in SPDj of &lt;1 lesion, or ≥50% increase in the longest diameter of a previous lesion &lt;1 cm in short axis;</p>
              <p>≥50% increase in circulating plasma cells (minimum of 200 cells per μL) if this is the only measure of disease.</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Clinical relapse</td>
            <td style={{ border: "1px solid black" }}>
              <p>Clinical relapse requires one or more of the following criteria:</p>
              <p>Direct indicators of increasing disease and/or end organ dysfunction (calcium elevation, renal failure, anemia, lytic bone lesions [CRAB features]) related to the underlying clonal plasma cell proliferative disorder. It is not used in calculation of time to progression or progression-free survival but is listed as something that can be reported optionally or for use in clinical practice;</p>
              <p>Development of new soft tissue plasmacytomas or bone lesions (osteoporotic fractures do not constitute progression);</p>
              <p>Definite increase in the size of existing plasmacytomas or bone lesions. A definite increase is defined as a 50% (and ≥1 cm) increase as measured serially by the SPDj of the measurable lesion;</p>
              <p>Hypercalcemia (&lt;11 mg/dL); Decrease in hemoglobin of ≥2 g/dL not related to therapy or other non–myeloma-related conditions;</p>
              <p>Rise in serum creatinine by 2 mg/dL or more from the start of the therapy and attributable to myeloma; Hyperviscosity related to serum paraprotein.</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Relapse from complete response (to be used only if the endpoint is disease-free survival)</td>
            <td style={{ border: "1px solid black" }}>
              <p>Any one or more of the following criteria:</p>   
              <p>Reappearance of serum or urine M-protein by immunofixation or electrophoresisi ;</p>
              <p>Development of ≥5% plasma cells in the bone marrow;</p>
              <p>Appearance of any other sign of progression (ie, new plasmacytoma, lytic bone lesion, or hypercalcemia) (see above).</p>
            </td>
          </tr>
          <tr>
            <td style={{ border: "1px solid black" }}>Relapse from MRD negative (to be used only if the endpoint is disease-free survival)</td>
            <td style={{ border: "1px solid black" }}>
              <p>Any one or more of the following criteria:</p>
              <p>Loss of MRD negative state (evidence of clonal plasma cells on NGF or NGS, or positive imaging study for recurrence of myeloma);</p>
              <p>Reappearance of serum or urine M-protein by immunofixation or electrophoresis;</p>
              <p>Development of ≥5% clonal plasma cells in the bone marrow;</p>
              <p>Appearance of any other sign of progression (ie, new plasmacytoma, lytic bone lesion, or hypercalcemia).</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}